<template>
  <div class="ts-overflow-y-scroll ts-h-11/12 ts-px-3">
    <div class="ts-space-y-5">
      <div
				 v-for="(data, index) in list.bets" :key="index"
				 style="width:fit-content"
				 class="ts-mx-auto ts-border-b-2 ts-border-gray-300 ts-px-3 ts-py-2 ts-rounded-lg ts-relative"
			>
				<span class="ts-cursor-pointer ts-absolute ts-top-0 ts-right-0"
					@click.prevent="$emit('deleteGame', index)"
				>
					<i class="far fa-times-circle ts-text-red-600"></i>
				</span>
        <ul class="ts-flex ts-space-x-2 ts-mt-4">
          <li  v-for="(num, index) in data.picked_number" :key="index">
            <div
              class="ts-rounded-full ts-mx-auto ts-h-8 ts-w-8 ts-flex ts-items-center ts-justify-center ts-font-bold ts-text-sm ts-cursor-pointer ts-border ts-text-gray-800"
              :class="list.game_type_id == 2 ? 'ts-border-green-500': 'ts-border-pink-600'"
            >{{ num.value }}</div>
          </li>
        </ul>
				<p class="ts-text-right ts-mb-0 ts-text-blue-800 ts-font-semibold">{{ $t('gameBetting.amount') + ' :  '+  (data.total_betting_amount) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cartList',
  props: ['list'],
  data() {
    return {}
	}
}
</script>